// extracted by mini-css-extract-plugin
export default {"arrow":"node-arrow_arrow__zidTz"};